import React, { Component } from 'react'
import { Hero } from '../../components/Layout'
import { TableLibrary, TableChannels } from './components'
import { Button } from 'antd'

export default class extends Component {
  componentDidMount () {
    const { getStorage, getTags, getChannels, getUsers, getGroups } = this.props

    getStorage()
    getTags()
    getChannels()
    getUsers()
    getGroups()
  }

  componentWillUnmount () {
    const { clearFilters } = this.props

    if (clearFilters) {
      clearFilters()
    }
  }

  render () {
    const {
      setTable,
      addTableItem,
      removeTableItem,

      groups,
      users,
      files,
      channels,
      table,
      tableChannels,
      selectedChannel,
      selectedDirectory,
      selectedDirectoryStack,

      updateTable,
      selectDirectory,
      getChannelById,
      setModal,
      createStorageAssignmentByArray,
      clearSelectedDirectory,
      clearSelectedChannel,
      toPreviousPage,

      addUsers,
      deleteUsers,
      addGroups,
      deleteGroups,

      lock,
      unlock,

      filters,
      storage,
      setFilterPagination
    } = this.props

    return (
      <div className='app__content'>
        <div className='content__hero'>
          <Hero wide heading='Channels' />
        </div>
        <div className='content__page'>
          <div className='container container_wide'>
            <div className='page'>
              <div className='page-channels page__channels'>

                <div className='page-channels__side'>
                  <div className='page-channels__top'>
                    <div className='page-channels__heading'>Library</div>
                  </div>
                  <div className='page-channels__content'>
                    <TableLibrary
                      setFilterPagination={setFilterPagination}
                      storage={storage}
                      table={table}
                      files={files}
                      filters={filters}
                      setTable={setTable}
                      addTableItem={addTableItem}
                      removeTableItem={removeTableItem}
                      selectedChannel={selectedChannel}
                      selectedDirectory={selectedDirectory}
                      createStorageAssignmentByArray={createStorageAssignmentByArray}
                    />
                  </div>
                </div>

                <div className='page-channels__transfer'>
                  <Button icon='right' disabled />
                </div>
                <TableChannels
                  groups={groups}
                  users={users}
                  channels={channels}
                  table={tableChannels}
                  selectedChannel={selectedChannel}
                  selectedDirectory={selectedDirectory}
                  selectedDirectoryStack={selectedDirectoryStack}

                  updateTable={updateTable}
                  getChannelById={getChannelById}
                  selectDirectory={selectDirectory}
                  setModal={setModal}
                  clearSelectedDirectory={clearSelectedDirectory}
                  clearSelectedChannel={clearSelectedChannel}
                  toPreviousPage={toPreviousPage}

                  addUsers={addUsers}
                  deleteUsers={deleteUsers}
                  addGroups={addGroups}
                  deleteGroups={deleteGroups}
                  lock={lock}
                  unlock={unlock}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/views/Channels/Channels.jsx